import { APIRoute } from '@/modules/utils'

export type Body = {
  token: string
}
export type Response = {}

export const Route: APIRoute = {
  method: 'POST',
  path: '/v2/reset-password/check-token',
}
